import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';
import DeleteServicePlanPricingPolicyFormModal from 'src/features/servicePlanPricingPolicies/components/forms/DeleteServicePlanPricingPolicyFormModal';
import UpdateServicePlanPricingPolicyFormModal from 'src/features/servicePlanPricingPolicies/components/forms/UpdateServicePlanPricingPolicyFormModal';
import { pricingPoliciesMessages } from 'src/features/servicePlanPricingPolicies/utils/messages';

type CellServicePlanPricingPolicyActionsProps = {
    row: Row<ServicePlanItemPricingPolicy>;
};

export default function CellServicePlanPricingPolicyActions({ row }: CellServicePlanPricingPolicyActionsProps) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateServicePlanPricingPolicyFormModal
                        semantics={{ entryName: formatMessage(pricingPoliciesMessages.policy).toLowerCase() }}
                        selectedServicePlanPricingPolicy={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateServicePlanPricingPolicyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteServicePlanPricingPolicyFormModal selectedServicePlanPricingPolicy={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteServicePlanPricingPolicyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
